/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppService {
  /**
   * 部署记录列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsDeployList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/deploy/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 列表 - 过滤字段
   * @returns any 成功
   * @throws ApiError
   */
  static getAppsPackageFilter() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/apps/package/filter'
    });
  }
  /**
   * 部署记录 - 删除/批量删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsDeployDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/deploy/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 重新部署
   * 部署列表的重新部署 传入参数 deployId
   * 节点总数里面的重新部署 传入参数 deployNodeIds
   * 两个参数必须存在一个
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsDeployRenew(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/deploy/renew',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsDeployNodeList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/deploy/node/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 获取日志SSE channel
   * @returns any 成功
   * @throws ApiError
   */
  static getAppsChannel() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/apps/channel'
    });
  }
  /**
   * 部署记录 - 节点总数 - 详情
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsDeployNodeDetail(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/deploy/node/detail',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 实时日志 (SSE)
   * @param deployNodeId 部署id
   * @param contentType
   * @returns any 成功
   * @throws ApiError
   */
  static getAppsDeployLogRealtime(deployNodeId, contentType) {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/apps/deploy/log/realtime',
      headers: {
        'Content-Type': contentType
      },
      query: {
        'deployNodeId': deployNodeId
      }
    });
  }
  /**
   * 应用状态 - 部署应用数量
   * @returns any 成功
   * @throws ApiError
   */
  static getAppsStateCount() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/apps/state/count'
    });
  }
  /**
   * 应用状态 - 状态列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsStateList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/state/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 应用状态 - 重启/批量重启
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsStateRestart(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/state/restart',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 应用状态 - 停止/批量停止
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsStateStop(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/state/stop',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 应用状态 - 卸载/批量卸载
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsStateUninstall(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/state/uninstall',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 应用状态 - 运行日志 (SSE)
   * @param id id
   * @param contentType
   * @returns any 成功
   * @throws ApiError
   */
  static getAppsStateLogRuntime(id, contentType) {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/apps/state/log/runtime',
      headers: {
        'Content-Type': contentType
      },
      query: {
        'id': id
      }
    });
  }
  /**
   * 新增 - 上传应用包
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsUpload(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/upload',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 新增 - 新增应用
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsAdd(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/add',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 查询应用列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsQuery(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/query',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 删除/批量删除应用
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 最新版本 - 应用版本列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageVersions(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/versions',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 节点列表
   * 包括 最新版本 - 部署 - 节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageNodesDeployed(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/nodes/deployed',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 已部署节点 - 节点列表
   * 包括 最新节点 - 已部署节点 - 节点列表
   * 注意：
   * 1. 应用中心的已部署节点不需要传入appVersion
   * 2. 最新节点里面的已部署节点，需要传入appVersion参数
   *
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageNodesStates(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/nodes/states',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 新增部署任务
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsDeploy(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/deploy',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 应用状态 - 启动
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsStateStart(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/state/start',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 最新版本 - 删除应用
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsDeleteOne(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/delete/one',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 查询应用所有版本
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageVersionsOne(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/versions/one',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 新增 - 确定 - 校验应用
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postAppsPackageActionsRepeat(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/apps/package/actions/repeat',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
}